import type { GetPhaseLabelsResponse } from '@vy/api-definition';
import { GetPhaseLabelsResponseSchema } from '@vy/api-definition';
import type { UseQueryOptions, QueryClient } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';

async function phaseLabelsQuery() {
  const privateApi = getPrivateApi();
  const phaseLabels = await privateApi.getPhaseLabels();

  return GetPhaseLabelsResponseSchema.parse(phaseLabels);
}

export function useGetPhaseLabels(options?: UseQueryOptions<GetPhaseLabelsResponse>) {
  const queryKey = queryKeys.phaseLabels();
  const response = useQuery({
    queryKey,
    queryFn: phaseLabelsQuery,
    ...options,
  });

  return response.data;
}

export async function prefetchGetPhaseLabels(queryClient: QueryClient) {
  return await queryClient.prefetchQuery(queryKeys.phaseLabels(), phaseLabelsQuery);
}
